<script setup>
import Button from './button/Button.vue';
defineProps({
  title: {
    type: String,
    required: true,
  },
  buttons: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['click', 'close']);

const handleButtonClick = button => {
  emit('click', button.key);
};
</script>

<template>
  <div
    class="flex items-center justify-between px-4 py-2 border-b border-n-weak h-12"
  >
    <div class="flex items-center min-w-0 gap-3">
      <span class="font-medium text-sm text-n-slate-12 truncate">{{
        title
      }}</span>
      <slot name="end" />
    </div>
    <div class="flex items-center">
      <Button
        v-for="button in buttons"
        :key="button.key"
        v-tooltip="button.tooltip"
        :icon="button.icon"
        ghost
        sm
        @click="handleButtonClick(button)"
      />
      <Button
        v-tooltip="$t('GENERAL.CLOSE')"
        icon="i-lucide-x"
        ghost
        sm
        @click="$emit('close')"
      />
    </div>
  </div>
</template>
